import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	type: {
		id: 'dynamic-cards-search-page.filters.names.type',
		defaultMessage: 'Type',
		description: 'Label for filtering by type',
	},
	filterTypePlaceholder: {
		id: 'dynamic-cards-search-page.filter.type.placeholder',
		defaultMessage: 'Find type',
		description: 'Placeholder for type filter search input',
	},
});
